<template>
  <Modal>
    <Modal.Body>
      <AddPaymentMethodBody :error-message="errorMessage" />
    </Modal.Body>
    <Modal.Footer>
      <Button
        variant="stroke"
        :size="isMobile ? 'lg' : 'md'"
        :disabled="loading"
        @click="close()"
      >
        Cancel
      </Button>
      <Button
        variant="primary"
        :size="isMobile ? 'lg' : 'md'"
        :loading="loading"
        @click="handleSave"
      >
        Save
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Button, useModal } from '@dacr/library'

import { useDevice } from '@/shared/composables/useDevice'
import AddPaymentMethodBody from './AddPaymentMethodBody.vue'
import { useAddPaymentMethod } from '../useAddPaymentMethod'

const { close } = useModal()
const { isMobile } = useDevice()
const { loading, errorMessage, save } = useAddPaymentMethod()

const handleSave = async () => {
  if (await save()) close()
}
</script>
